<div mat-dialog-title class="title-text">{{title}}</div>
<div mat-dialog-content mat-tipography>
    <div class="message" [innerHtml]="html"></div>
</div>
<div mat-dialog-actions>
    @if (mode==='YESNO') {
    <button mat-stroked-button (click)="dialogRef.close('no')">
        <div>{{ buttonNoText }}</div>
    </button>
    <button mat-flat-button cdkFocusInitial (click)="dialogRef.close('yes')">
        <span>{{ buttonYesText }}</span>
    </button>
    } @else if (mode === 'OK') {
    <button mat-flat-button cdkFocusInitial (click)="closeDialog()">
        <span>{{ buttonOkText }}</span>
    </button>
    }


</div>